import {
	StyledShareForm,
	StyledShareImg,
	StyledShareContentContainer,
	StyledShareLinksContainer,
	StyledShareTitle,
} from 'components/Selfiebooth/ShareDisplay/styled'
import Controls from 'components/Selfiebooth/ShareDisplay/controls'
import React from 'react'
import Facebook from 'components/Selfiebooth/ShareDisplay/facebook'
import CopyLink from 'components/Selfiebooth/ShareDisplay/copylink'
import Download from 'components/Selfiebooth/ShareDisplay/download'
import { SelfieBoothType } from '../../../types/selfiebooth'
import { withTranslation } from 'react-i18next'

interface ShareProps {
	app: any;
	selfiebooth: SelfieBoothType;
	onCancel: () => void;
	finalImg: string;
	fileId: string | null;
	t: any;
}

const Share = ({ app, selfiebooth, finalImg, fileId, onCancel, t }: ShareProps) => {
	const { part: infos } = selfiebooth;

	return <>
		<StyledShareContentContainer>
			<Controls source="share" onCancel={onCancel} />
			<StyledShareImg src={finalImg} />
			<StyledShareForm>
				<StyledShareTitle>{infos.shareAdmin.thanks || t('photobooth.thanks')}</StyledShareTitle>
			</StyledShareForm>
			<StyledShareLinksContainer>
				{fileId && infos.shareFacebook.show && <Facebook share={infos.shareFacebook} fileId={fileId} app={app} selfiebooth={selfiebooth} />}
				{fileId && infos.shareLink.show && <CopyLink share={infos.shareLink} fileId={fileId} app={app} selfiebooth={selfiebooth} />}
				{infos.shareDownload.show && <Download share={infos.shareDownload} finalImg={finalImg} />}
			</StyledShareLinksContainer>
		</StyledShareContentContainer>
	</>
};

export default withTranslation()(Share);
